// Libs
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  createNote,
  createNoteSchedule,
  deleteNote,
  getListNote,
  getNoteScheduleList,
  updateNote,
} from '~/thunks/notes/notesThunk';

export interface ScheduleState {
  isRefreshNoteSchedule: boolean;
  isRefreshNote: boolean;
}

const initialState: ScheduleState = {
  isRefreshNoteSchedule: false,
  isRefreshNote: false,
};

const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    setIsRefreshNoteScheduleData(state, action: PayloadAction<boolean>) {
      state.isRefreshNoteSchedule = action.payload;
    },
    setIsRefreshNote(state, action: PayloadAction<boolean>) {
      state.isRefreshNote = action.payload;
    },
  },
  extraReducers(builder) {
    // POST: Create note schedule
    builder
      .addCase(createNoteSchedule.pending, (state) => {})
      .addCase(createNoteSchedule.fulfilled, (state) => {
        state.isRefreshNoteSchedule = true;
      })
      .addCase(createNoteSchedule.rejected, (state) => {});

    // GET: Get note schedule list
    builder
      .addCase(getNoteScheduleList.pending, (state) => {})
      .addCase(getNoteScheduleList.fulfilled, (state) => {
        state.isRefreshNoteSchedule = false;
      })
      .addCase(getNoteScheduleList.rejected, (state) => {});

    // GET: Get list note
    builder
      .addCase(getListNote.pending, (state) => {})
      .addCase(getListNote.fulfilled, (state) => {
        state.isRefreshNote = false;
      })
      .addCase(getListNote.rejected, (state) => {});

    // POST: Create note
    builder
      .addCase(createNote.pending, (state) => {})
      .addCase(createNote.fulfilled, (state) => {})
      .addCase(createNote.rejected, (state) => {});

    // PUT: Update note
    builder
      .addCase(updateNote.pending, (state) => {})
      .addCase(updateNote.fulfilled, (state) => {})
      .addCase(updateNote.rejected, (state) => {});

    // DELETE: Delete note
    builder
      .addCase(deleteNote.pending, (state) => {})
      .addCase(deleteNote.fulfilled, (state) => {})
      .addCase(deleteNote.rejected, (state) => {});
  },
});

// Action
export const notesActions = notesSlice.actions;

// Selectors
export const selectIsRefreshNoteSchedule = (state: RootState) => state.notes.isRefreshNoteSchedule;
export const selectIsRefreshNote = (state: RootState) => state.notes.isRefreshNote;

// Reducer
const notesReducer = notesSlice.reducer;
export default notesReducer;
